import React, { useEffect, useRef, useState } from 'react';

export const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="about"
      ref={sectionRef}
      className="py-24 md:py-32 bg-white">

      <div className="max-w-6xl mx-auto px-6">
        {/* Main Content */}
        <div className={`space-y-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          {/* Intro */}
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-light mb-8 tracking-tight">
              Evolving with intent
            </h2>
            <p className="text-lg md:text-xl text-gray-600 font-light leading-relaxed">
              In a digital world that never sits still, we are a creative studio built for brands that want to stay relevant. 
              In a landscape defined by constant change, relevance isn't about reacting—it's about evolving with intent.
            </p>
          </div>

          {/* Two Column Section */}
          <div className="grid md:grid-cols-2 gap-16 mt-20">
            {/* Left Column */}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl md:text-3xl font-light mb-4">
                  Storytelling × Intelligence
                </h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  At Caribou Studio, we bring together the timeless power of storytelling and the transformative 
                  potential of AI to help brands adapt, connect, and grow.
                </p>
              </div>

              <div>
                <p className="text-gray-600 font-light leading-relaxed">
                  We believe AI is not a replacement for creativity, but its greatest amplifier. When used thoughtfully, 
                  AI unlocks possibilities that were once limited by time, resources, or budget. It allows brands to 
                  imagine bigger, test faster, and produce smarter.
                </p>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl md:text-3xl font-light mb-4">
                  Experience Gives Technology a Soul
                </h3>
                <p className="text-gray-600 font-light leading-relaxed">
                  Caribou Studio is powered by seasoned advertising professionals with years of expertise across copy, 
                  design, films, and digital campaigns. We understand brands because we've shaped them in real-world 
                  creative environments.
                </p>
              </div>

              <div>
                <p className="text-gray-600 font-light leading-relaxed">
                  Strategy guides our ideas, craft defines our execution, and storytelling anchors everything we create. 
                  We experiment boldly with AI, formats, and platforms—not for novelty, but to discover what truly works.
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="max-w-4xl mx-auto text-center mt-20 pt-16 border-t border-gray-200">
            <p className="text-2xl md:text-3xl font-light text-gray-800 mb-6">
              Whether it's AI-crafted films, real-world shoots, immersive websites, or scroll-stopping social content
            </p>
            <p className="text-lg text-gray-600 font-light leading-relaxed">
              We create stories designed to move fluidly across mediums. Every idea is shaped to cut through noise, 
              connect with audiences, and scale naturally in a digital-first world.
            </p>
          </div>

          {/* Closing Statement */}
          <div className="max-w-3xl mx-auto text-center mt-20">
            <p className="text-xl md:text-2xl font-light italic text-gray-700">
              
              <br />
              
            </p>
          </div>
        </div>
      </div>
    </section>);

};